<!--
  After a discussion with @ghetolay and @broweratcognitedotcom on gitter.im/angula/angular
  it seems like there's currently no other solution than using ngSwitch for
  properly supporting different Material buttons in a custom component. (08.01.2019)
-->

<!-- Button inner template -->
<ng-template #content>
  <div class="button-content-wrapper">
    <!-- Button content -->
    <div [class.hidden]="loading">
      <ng-content></ng-content>
    </div>

    <!-- Loading/Progress indicator -->
    <mat-progress-spinner class="button-progress"
                          [class.white]="!disabled"
                          [class.hidden]="!loading"
                          [mode]="loadingType"
                          [value]="loadingProgress"
                          [diameter]="loaderDiameter">
    </mat-progress-spinner>
  </div>
</ng-template>

<ng-container [ngSwitch]="buttonStyle">
  <!-- mat-button -->
  <ng-container *ngSwitchCase="'mat-button'">
    <button mat-button
            (click)="onButtonClick($event)"
            [disabled]="disabled"
            [color]="color"
            [style.width]="width"
            [type]="type">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </button>
  </ng-container>

  <!-- mat-flat-button -->
  <ng-container *ngSwitchCase="'mat-flat-button'">
    <button mat-flat-button
            (click)="onButtonClick($event)"
            [disabled]="disabled"
            [color]="color"
            [style.width]="width"
            [type]="type">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </button>
  </ng-container>

  <!-- mat-icon-button -->
  <ng-container *ngSwitchCase="'mat-icon-button'">
    <button mat-icon-button
            (click)="onButtonClick($event)"
            [disabled]="disabled"
            [color]="color"
            [style.width]="width"
            [type]="type">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </button>
  </ng-container>

  <!-- mat-raised-button -->
  <ng-container *ngSwitchCase="'mat-raised-button'">
    <button mat-raised-button
            (click)="onButtonClick($event)"
            [disabled]="disabled"
            [color]="color"
            [style.width]="width"
            [type]="type">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </button>
  </ng-container>

  <!-- mat-stroked-button -->
  <ng-container *ngSwitchCase="'mat-stroked-button'">
    <button mat-stroked-button
            (click)="onButtonClick($event)"
            [disabled]="disabled"
            [color]="color"
            [style.width]="width"
            [type]="type">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </button>
  </ng-container>

  <!-- mat-mini-fab -->
  <ng-container *ngSwitchCase="'mat-mini-fab'">
    <button mat-mini-fab
            (click)="onButtonClick($event)"
            [disabled]="disabled"
            [color]="color"
            [type]="type">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </button>
  </ng-container>

  <!-- mat-fab -->
  <ng-container *ngSwitchCase="'mat-fab'" >
    <button mat-fab
            (click)="onButtonClick($event)"
            [disabled]="disabled"
            [color]="color"
            [style.width]="width"
            [type]="type">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </button>
  </ng-container>
</ng-container>
